import { useState, useEffect } from 'react';
import { Checkbox, Currency, IconSearch, InputText } from '@ui/src';
import { useAppSelector } from '@store';

import cn from './styles.module.css';

const PaymentTypeForm = ({
  availableCurrencies,
  setAvailableCurrencies,
}: {
  availableCurrencies: Currency[];
  setAvailableCurrencies: (data: Currency[]) => void;
}) => {
  const [currenciesList, setCurrenciesList] = useState<Currency[]>([]);
  const [searchValue, setSearchValue] = useState('');

  const { activeCurrencies } = useAppSelector(
    (state) => state.administrationDictionaries,
  );

  const onSearch = (text: string) => {
    setSearchValue(text);

    if (text) {
      const nextCurrencies = activeCurrencies?.filter((item) =>
        item.name.toLocaleLowerCase().includes(text.toLocaleLowerCase()),
      );

      setCurrenciesList(nextCurrencies as Currency[]);
    } else {
      setCurrenciesList(activeCurrencies as Currency[]);
    }
  };

  useEffect(() => {
    if (activeCurrencies) {
      setCurrenciesList(activeCurrencies);
    }
  }, [activeCurrencies]);

  return (
    <>
      <div className={cn.searchCurrencyWrapper}>
        <IconSearch className={cn.searchIcon} />
        <InputText
          name="search"
          placeholder="Currency name"
          value={searchValue}
          className={cn.searchInput}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>
      <div className={cn.availableCurrenciesWrapper}>
        {!currenciesList.length && (
          <div className={cn.noCurrencies}>No currencies yet</div>
        )}
        {currenciesList?.map((item) => (
          <div className={cn.currencyCheckbox} key={item.id}>
            <Checkbox
              name={`checkbox-${item.id}`}
              checked={Boolean(
                availableCurrencies?.find(
                  (currency) => currency.id === item.id,
                ),
              )}
              type="checkbox"
              title={item.name}
              onChange={(e) => {
                let nextAvailableCurrencies = ([] as Currency[]).concat(
                  availableCurrencies,
                );

                if (e.target.checked) {
                  nextAvailableCurrencies?.push(item);
                } else {
                  nextAvailableCurrencies = nextAvailableCurrencies?.filter(
                    (currency) => currency.id !== item.id,
                  );
                }

                setAvailableCurrencies(nextAvailableCurrencies);
              }}
            />
            <div className={cn.currencyDescription}>{item.description}</div>
          </div>
        ))}
      </div>

      <div />
    </>
  );
};

export default PaymentTypeForm;
